import { createApp } from "vue";

//Set up observer dynamically importing vue components
export const VueAppObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach(async (entry, index) => {
      let module;
      const designsystem = entry.target.dataset.designSystem;
      //Pulls the filename and path from dataset, generates a Vue app, then passes props via dataset.context
      const fileName = entry.target.dataset.observedApp;
      const moduleParentDirectory =
        entry.target.dataset.observedAppPath ?? fileName;
      if (entry.intersectionRatio > 0) {
        if (designsystem === "true") {
          module = await import(
            `../../../designsystem/src/components/${moduleParentDirectory}/${fileName}.vue`
          );
        } else {
          module = await import(`../${moduleParentDirectory}/${fileName}.vue`);
        }
        const app = createApp(
          module.default,
          JSON.parse(entry.target.dataset.context)
        );
        app.config.idPrefix = index + "__" + Date.now();
        app.mount(entry.target);

        VueAppObserver.unobserve(entry.target);
        entry.target.classList.add("js-observed");
      }
    });
  },
  {
    rootMargin: "0px 0px 300px 0px",
  }
);
